import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dara_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

/**
 * Normalize FastAPI's 422 response. When validation fails, FastAPI returns
 * `{detail: [{type, loc, msg, input, ctx, url}, ...]}` — an array of objects.
 * Naive callers that did `setError(err.response.data.detail)` then rendered
 * the value crashed React with "Objects are not valid as a React child".
 * This interceptor flattens the array into a human-readable string before
 * any caller sees it.
 */
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
      const text = detail
        .map((d) => {
          if (!d || typeof d !== "object") return String(d);
          const loc = Array.isArray(d.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
          const msg = d.msg || d.message || "Invalid";
          return loc ? `${loc}: ${msg}` : msg;
        })
        .join("; ");
      err.response.data.detail = text || "Validation failed";
    }
    return Promise.reject(err);
  },
);
